module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/nagoya_concept_01-849cce2832f5c68f085c9691d293c13a.jpg";